import { CommonDropdownControlDirective } from 'app/shared/directives/control/common-dropdown-control.directive';
import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
@Component({
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CommonDropdownComponent)
        }
    ],
    selector: 'kh-common-dropdown',
    styleUrls: ['./common-dropdown.component.less'],
    templateUrl: './common-dropdown.component.html',
    standalone: false
})
export class CommonDropdownComponent<TItem, TValue> extends CommonDropdownControlDirective<TItem, TValue> {
}
